export const GET_USER_BALANCE = 'GET_USER_BALANCE';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_DETAIL_DATA = 'GET_DETAIL_DATA';
export const UPDATE_VOTE_NUM = 'UPDATE_VOTE_NUM';
export const UPDATE_BALANCE = 'UPDATE_BALANCE';

